@if (success!.length > 0) {
  <div class="alert  alert-success error pill form-error-list">
    <div id="{{ id }}-success" class="error-list-wrapper" [attr.aria-live]="'assertive'">
      <ul>
        @for (msg of success; track msg) {
          <li [id]="msg.code"><span [innerHtml]="messages.getText(msg.code)"></span></li>
        }
      </ul>
    </div>
  </div>
}

@if (errors!.length > 0) {
  <div class="alert  alert-error error pill form-error-list">
    <div id="{{ id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
      <ul>
        @for (msg of errors; track msg) {
          <li [id]="msg.code">
            <span [innerHtml]="messages.getText(msg.code)"></span>
          </li>
        }
      </ul>
    </div>
  </div>
}

@if (warnings!.length > 0) {
  <div class="alert  alert-warning error pill form-error-list">
    <div id="{{ id }}-warn" class="error-list-wrapper" [attr.aria-live]="'assertive'">
      <ul>
        @for (msg of warnings; track msg) {
          <li [id]="msg.code">
            <span [innerHtml]="messages.getText(msg.code)"></span>
          </li>
        }
      </ul>
    </div>
  </div>
}

@if (queries!.length > 0) {
  <div class="alert  alert-query error pill form-error-list">
    <div id="{{ id }}-warn" class="error-list-wrapper" [attr.aria-live]="'assertive'">
      <ul>
        @for (msg of queries; track msg) {
          <li [id]="msg.code">
            <span [innerHtml]="messages.getText(msg.code)"></span>
          </li>
        }
      </ul>
    </div>
  </div>
}
